import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoCheckGreen, LazySvgoCheck, LazySvgoCluth, LazySvgoGoodFirm, LazySvgoMarkerPin04, LazySvgoMarkerPin05, LazySvgoNext, LazySvgoPrev, LazySvgoQuote, LazySvgoSmallBlobsLight, LazySvgoStar, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["SvgoCheckGreen", LazySvgoCheckGreen],
["SvgoCheck", LazySvgoCheck],
["SvgoCluth", LazySvgoCluth],
["SvgoGoodFirm", LazySvgoGoodFirm],
["SvgoMarkerPin04", LazySvgoMarkerPin04],
["SvgoMarkerPin05", LazySvgoMarkerPin05],
["SvgoNext", LazySvgoNext],
["SvgoPrev", LazySvgoPrev],
["SvgoQuote", LazySvgoQuote],
["SvgoSmallBlobsLight", LazySvgoSmallBlobsLight],
["SvgoStar", LazySvgoStar],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
